module.exports = __webpack_public_path__ + "img/the_trade_desk.d337ade.png";